import React from 'react';
import { useRequest } from 'ahooks';
import { api } from "@redux/api";
import ColumnChart from "@containers/UtilityData/Charts/ColumnChart";
import { useAuth } from '@/hooks/use-auth';
import { Nopermission } from '@/components/Nopermission';
import { useNavigate } from 'react-router-dom';
import { emitEvent } from '@/hooks/useEventBus';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '@redux/app/actions';
import { buildFacilityPath, getFacilityContext } from '@/utils/route-context';

const WorkorderSummaryChart = () => {
    const workorderPermission = useAuth('workorder', 1);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const facilityId = useSelector(state => state?.Facility?.selected?.Id);
    const facilityContext = useSelector((state) => getFacilityContext(state));

    const { data: workorderData } = useRequest(
        () => api.allworkorderview(),
        {
            ready: workorderPermission,
            cacheKey: `workorder-summary-chart-data-${facilityId}`,
            staleTime: 1 * 60 * 1000, // 1分钟缓存
        }
    );

    if (!workorderPermission) {
        return <Nopermission />;
    }

    const past7Past30Data = workorderData?.data?.past7_past30;

    if (!past7Past30Data) {
        return null
    }

    const handleWorkSummaryClick = (e) => {
        emitEvent('CLOSE_WORKORDER');
        let params = '';
        switch (e.date_range) {
            case 'Past 30 Days':
                params += 'modify_date=' + 30;
                break;
            case 'Past 7 Days':
                params += 'modify_date=' + 7;
                break;
            case 'Past 90 Days':
                params += 'modify_date=' + 90;
                break;
        }
        params += '&status=' + e.status;

        const url = buildFacilityPath('workorder', {
            ...facilityContext,
            query: params,
        }) || '/switch-view';
        navigate(url);
        dispatch(appActions.changeCurrent(['workorder']));
    };

    return (
        <ColumnChart
            data={past7Past30Data}
            title='Workorder Summary'
            slider={false}
            isStack={false}
            isGroup={true}
            handleChartClick={handleWorkSummaryClick}
        />
    );
};

export default WorkorderSummaryChart; 
